<template>
<div>
  <div class="manage-division-title">
    Organization Chart > จัดการส่วนงาน
  </div>
  <div class="text-center">
    <v-layout class="row" style="margin-right: 0px">
      <v-col cols="">
      <p class="txt-font" style="text-align: left;">ชื่อส่วนงาน</p>
        <v-text-field
          v-model="name"
          dense
          label="ค้นหา ชื่อส่วนงาน"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="">
      <p class="txt-font" style="text-align: left;">สายงานบังคับบัญชา</p>
        <v-select
            label="ค้นหา สายงานบังคับบัญชา"
            :items="nameHeaderList"
            v-model="headerName"
            dense
            outlined
            small-chips
            multiple
          ></v-select>
      </v-col>
      <v-col cols="">
      <p class="txt-font" style="text-align: left;">ชื่อย่อบริษัท</p>
        <v-select
            label="ค้นหา ชื่อย่อบริษัท"
            :items="companyNameList"
            v-model="companyName"
            dense
            outlined
            small-chips
            multiple
          ></v-select>
      </v-col>
      <v-col cols="">
      <p class="txt-font" style="text-align: left;">ชื่อเครือ</p>
        <v-select
            label="ค้นหา ชื่อเครือ"
            :items="groupCompanyList"
            v-model="groupCompany"
            dense
            outlined
            small-chips
            multiple
          ></v-select>
      </v-col>
      </v-layout>
  </div>
      <v-data-table
      :headers="headers"
      :items="desserts"
      class="elevation-1"
      :items-per-page="5"
      item-key="_id"
      :expanded.sync="expanded"
      show-expand
      disable-sort
  >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <!-- <v-toolbar-title>Employee</v-toolbar-title> -->
          <!-- <v-divider
            class="mx-4"
            inset
            vertical
          ></v-divider> -->
          <v-spacer></v-spacer>
          <v-btn class="ma-2" tile color="success" @click="goPageCreate()">
            <v-icon left>mdi-plus</v-icon> Create
          </v-btn>
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
          >
            Import
            <v-icon right dark>mdi-cloud-upload</v-icon>
          </v-btn>
          <v-btn
            color="blue-grey"
            class="ma-2 white--text"
          >
            Export
            <v-icon right dark>mdi-cloud-download</v-icon>
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
      <v-btn class="ma-2" outlined x-small fab color="indigo" @click="openDialogCreate('View')">
        <v-icon>mdi-eye</v-icon>
      </v-btn>
      <v-btn class="ma-2" outlined x-small fab color="red" @click="deleteItem(item)">
        <v-icon>mdi-delete</v-icon>
      </v-btn>
      <v-btn class="ma-2" outlined x-small fab color="green" @click="dialogManageCompany = true">
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
     <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="padding-left-90">
            <v-treeview open-all :items="item.children" class="pa-0">
              <template slot="label" slot-scope="props">
                <span v-if="props.item.managementLevel.split('.').length < 3">ลำดับสายงานที่ {{props.item.managementLevel}}</span>
                <div v-if="props.item.managementLevel.split('.').length > 2" class="table-name-row">
                  <span>ชื่อ : สายงานย่อย {{props.item.managementLevel}}</span>
                  <span class="ml-2">ผู้บังคับบัญชา : {{props.item.userName}}</span>
                  <span class="ml-2">ตำแหน่ง : {{props.item.userPosition}}</span>
                </div>
              </template>
            </v-treeview>
          </td>
        </template>
    </v-data-table>
</div>
</template>
<script>
import { EventBus } from '@/EventBus'
// import Table from './_overview/table'
export default {
  components: {
    // Table
  },
  data () {
    return {
      expanded: [],
      singleExpand: false,
      dialog: false,
      dialogCreate: false,
      tab: null,
      textTitle: 'Create New',
      e1: 1,
      steps: 2,
      nameHeaderList: ['INET', 'OGS'],
      companyNameList: ['INET', 'OGS'],
      groupCompanyList: ['INET', 'OGS'],
      name: '',
      headerName: '',
      companyName: '',
      groupCompany: '',
      headers: [
        {
          text: 'No.',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'ชื่อส่วนงาน', value: 'orgChartName' },
        { text: 'สายงานบังคับบัญชา', value: 'orgChartHeaderName' },
        { text: 'ชื่อย่อบริษัท', value: 'companyShortNameEng' },
        { text: 'ชื่อเครือ', value: 'groupCompanyName' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      desserts: [
        {
          id: '1',
          orgChartName: 'Network Operation',
          orgChartHeaderName: 'ฝ่ายงาน Paperless Platform',
          companyShortNameEng: 'INET',
          groupCompanyName: 'INET',
          no: ''
        }
      ],
      itemsBread: [
        {
          text: 'Organization',
          disabled: false,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'จัดการส่วนงาน',
          disabled: false,
          href: 'breadcrumbs_link_1'
        }
      ]
    }
  },
  mounted () {
    // EventBus.$on('opendialogcreate', this.openDialogCreate)
    // EventBus.$on('closedialogcreate', this.closeDialogCreate)
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.getDivisionLists()
    this.getSelectCompany()
  },
  watch: {
    name: function (val) {
      // console.log('Name Th', this.name)
      this.getDivisionLists()
    },
    headerName: function (val) {
      // console.log('Name Engggg', this.headerName)
      this.getDivisionLists()
    },
    companyName: function (val) {
      // console.log('Name Engggg', this.companyName)
      this.getDivisionLists()
    },
    groupCompany: function (val) {
      // console.log('Name Engggg', this.groupCompany)
      this.getDivisionLists()
    }
  },
  methods: {
    goPageCreate () {
      // console.log('Go Create')
      this.$router.push('/managedivision/createDivision')
    },
    async getSelectCompany () {
      await this.axios({
        method: 'get',
        url: `${this.api}/api/vMonk/section/getSelectSection`
      }).then((response) => {
        // console.log('Data Division', response.data.result)
        this.nameHeaderList = response.data.result.orgChartHeaderName
        this.companyNameList = response.data.result.companyShortNameEng
        this.groupCompanyList = response.data.result.groupCompanyName
      }).catch(e => {
        console.log(e)
      })
    },
    async getDivisionLists () {
      const temp = []
      await this.axios({
        method: 'post',
        url: `${this.api}/api/vMonk/section/getSectionOverview`,
        data: {
          name: this.name,
          headerName: this.headerName,
          companyName: this.companyName,
          groupCompany: this.groupCompany,
          limit: 50,
          page: 1
        }
      }).then((response) => {
        if (response.data.success) {
          if (response.data.result.length) {
            response.data.result.map((el, index) => {
              temp.push({
                no: index + 1,
                ...el
              })
            })
            this.desserts = temp
            // console.log('dessert', this.desserts)
          }
        } else {
          // console.log(response)
        }
      }).catch(e => {
        console.log(e)
      })
    },
    nextStep (n) {
      if (n === this.steps) {
        this.e1 = 1
      } else {
        this.e1 = n + 1
      }
    },
    editCompany (value) {
      this.textTitle = ''
      // this.dialogCreate = true
      this.textTitle = value
    },
    openDialogCreate () {
      this.dialogCreate = true
      EventBus.$emit('opendialogcreate', this.dialogCreate)
    },
    // closeDialogCreate (value) {
    //   this.dialogCreate = value
    // },
    closeDialog () {
      this.textTitle = 'Create New'
      this.dialogCreate = false
    }
  }
}
</script>

<style scoped>
.v-input {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}
.txt-font {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
}
.txt-head {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
}
.manage-division-title {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: bold;
  font-size: 1.5rem;
}
</style>
